module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeEntry.date),
      expression: "timeEntry.date"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "placeholder": "Date"
    },
    domProps: {
      "value": (_vm.timeEntry.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.timeEntry, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Hours")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeEntry.totalTime),
      expression: "timeEntry.totalTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Hours"
    },
    domProps: {
      "value": (_vm.timeEntry.totalTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.timeEntry, "totalTime", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Comment")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeEntry.comment),
      expression: "timeEntry.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Comment"
    },
    domProps: {
      "value": (_vm.timeEntry.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.timeEntry, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/time-entries/'
    }
  }, [_c('a', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('hr')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ecf8e97c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogTime.vue
// module id = 375
// module chunks = 2